import { render, staticRenderFns } from "./ModalPrivacy.vue?vue&type=template&id=04a2161f&scoped=true"
import script from "./ModalPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacy.vue?vue&type=script&lang=js"
import style0 from "./ModalPrivacy.vue?vue&type=style&index=0&id=04a2161f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a2161f",
  null
  
)

export default component.exports